import createHostComponent from '../../createHostComponent';
import defaults from './props/default';
var Image = createHostComponent('image', null, defaults);
export default Image;
